import { gsap } from 'gsap'


export class SimpleHero
{
  constructor(block) {

    this.img = block.querySelector('img')
    this.contentWrapper = block.querySelector('.container')

    if(this.img) {
      gsap.set(this.img, { scale: 1 })
    }

    gsap.set(this.contentWrapper, { scale: 0.8, y: 50 })


    const self = this

    setTimeout(function () {

      if(self.img) {
        gsap.to(self.img, { scale: 1.1, duration: 0.75 })
      }

      gsap.to(self.contentWrapper, { scale: 1,y: 0, duration: 0.75 })

    }, 75)

  }
}

const heroBlocks = document.querySelectorAll('.block-simple-page-hero')
heroBlocks.forEach( block => {
  new SimpleHero(block)
})
